import { render, staticRenderFns } from "./bofang.vue?vue&type=template&id=0d3488d2"
import script from "./bofang.vue?vue&type=script&lang=js"
export * from "./bofang.vue?vue&type=script&lang=js"
import style0 from "./bofang.vue?vue&type=style&index=0&id=0d3488d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports